import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'styles/ink-contact-menu.css';

export default function InkContactMenu() {
  const menu = useRef(null);
  const location = useLocation();
  const close = () => { if (menu.current) menu.current.open = false; };
  useEffect(close, [location.pathname, location.hash]);
  useEffect(() => {
    const outside = event => { if (!menu.current?.contains(event.target)) close(); };
    document.addEventListener('pointerdown', outside);
    return () => document.removeEventListener('pointerdown', outside);
  }, []);
  return <details ref={menu} className="ink-contact-menu" onKeyDown={event => {
    if (event.key === 'Escape' && menu.current?.open) {
      event.preventDefault(); close(); menu.current.querySelector('summary').focus();
    }
  }}>
    <summary>Contact <span aria-hidden="true">⌄</span></summary>
    <div className="ink-contact-menu-links">
      <Link to="/ink/report-bug" onClick={close}>Report a bug</Link>
      <Link to="/ink/suggest-feature" onClick={close}>Suggest a feature</Link>
      <Link to="/get-ink#contact" onClick={close}>Licence enquiries</Link>
    </div>
  </details>;
}
